import fetch from '@api/fetchers';

interface ParentContactOtpParams {
  phone: string;
  countryCode: string;
}

interface ParentContactVerifyParams extends ParentContactOtpParams {
  otp: string;
}

export const fetchParentContactStatus = () =>
  fetch('v1/user/parent_contact/status/', {
    requestType: 'GET'
  });

export const sendParentContactOtp = ({
  phone,
  countryCode
}: ParentContactOtpParams) =>
  fetch('v1/user/parent_contact/send_otp/', {
    requestType: 'POST',
    body: {
      phone,
      country_code: countryCode
    }
  });

export const verifyParentContactOtp = ({
  phone,
  countryCode,
  otp
}: ParentContactVerifyParams) =>
  fetch('v1/user/parent_contact/verify/', {
    requestType: 'POST',
    body: {
      phone,
      country_code: countryCode,
      otp
    }
  });
